
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../ui/TabBarCard.css';
import { faFilter, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

function TabBarCard({ tabData, tabSelected, tabClikHandler }) {

    /* 
        tabData-Данные для меню
        setData-Изменение данных меню       
        setAddShow - откроет модальное окно добавления
        handlerMenuClick - оброботчик клика по tab
   
        [
            { id_tab: 0, name: "Черновики", icon: faPen, showCount: true, count: 2 }
            , { id_tab: 1, name: "Исполнитель", icon: faCheck, showCount: false}
            , { id_tab: 2, name: "Наблюдатель", icon: faEye, showCount: false}
            , { id_tab: 3, name: "Будущие", icon: faRocket, showCount: false }
            , { id_tab: 4, name: "Все задачи", icon: faUsers, showCount: false }
            , { id_tab: 5, name: "Выполненные", icon: faFlagCheckered, showCount: false}
        ];
    */
    const stateSize = useSelector((state) => state.size);

    function change(id_tab) {
        tabClikHandler(id_tab)
    }

    return (
        <>

            <div className='tabbar-card-container'>

                <div className="tabbar-card-block-btn">
                    <div className='tabbar-card-item first'></div>
                    {tabData.map(item => (
                        <div key={item.id_tab} className='tabbar-card-item'>
                            <button className={item.id_tab === tabSelected ? "tabbar-card-button-menu active" : "tabbar-card-button-menu"} onClick={() => change(item.id_tab)}>
                                <FontAwesomeIcon icon={item.icon} className="mr-5" />{item.name}
                                {item.count > 0 && <small>({item.count})</small>}
                            </button>
                        </div>
                    ))}
                    <div className='tabbar-card-item last'></div>
                </div>
            </div>

        </>
    )
}
export default TabBarCard;